declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

// Manual page_view sender for SPA route changes — gtag's own automatic
// page_view (fired once on initial script load) is disabled in
// public/index.html since it would never fire again after that.
export const trackPageView = (path: string, title?: string) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
};

// Generic GA4 custom event — prefer the specific helpers below (trackCta,
// trackNavClick, ...) so event names/params stay consistent across the
// site instead of every call site inventing its own shape.
export const trackEvent = (action: string, params?: Record<string, any>) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", action, params);
};

// `location` = where on the page the element lives (e.g. "hero",
// "header", "footer", "mobile_menu") — lets the same label (e.g. "Start
// Free Trial") be told apart by placement in GA reports.
export const trackCta = (label: string, location: string) =>
  trackEvent("cta_click", { label, location });

export const trackNavClick = (label: string, location: string) =>
  trackEvent("nav_click", { label, location });

export const trackWhatsappClick = (location: string) =>
  trackEvent("whatsapp_click", { location });

export const trackContactSubmit = () => trackEvent("contact_submit", {});
